import { Component } from '@angular/core';

@Component({
  selector: 'app-app-version',
  templateUrl: './app-version.component.html',
  styleUrls: ['./app-version.component.scss']
})
export class AppVersionComponent {
  androidVersion: string = '';
  androidDowntimeStart: string = '';
  androidDowntimeEnd: string = '';
  androidDowntimeActive: boolean = false;

  iosVersion: string = '';
  iosDowntimeStart: string = '';
  iosDowntimeEnd: string = '';
  iosDowntimeActive: boolean = false;


  saveData(platform: string) {
    if (platform === 'android') {
      console.log({
        platform: 'Android',
        version: this.androidVersion,
        downtimeStart: this.androidDowntimeStart,
        downtimeEnd: this.androidDowntimeEnd,
        downtimeActive: this.androidDowntimeActive
      });
    } else {
      console.log({
        platform: 'iOS',
        version: this.iosVersion,
        downtimeStart: this.iosDowntimeStart,
        downtimeEnd: this.iosDowntimeEnd,
        downtimeActive: this.iosDowntimeActive
      });
    }
    alert(`${platform.toUpperCase()} data saved successfully!`);
  }
}
